import { Auth } from "aws-amplify";

export async function getAccessToken() {
  const response = await Auth.currentSession();
  return response?.idToken?.jwtToken;
}
